<template>
  <v-container
    data-aos="fade"
    v-if="!loading"
  >
    <h1 class="mb-6 text-center">{{title}}</h1>
    <v-row>
      <v-col cols="12" v-if="events.length === 0">
        <slot name="empty"></slot>
      </v-col>
      <v-col
        cols="8"
        offset="2"
        sm="6"
        offset-sm="0"
        :lg="lg"
        v-for="(event, index) in events"
        :key="index"
        class="pa-2"
      >
        <event-card
          :aspect-ratio="aspectRatio"
          :disabled="disabled"
          :event="event"
        ></event-card>
      </v-col>
    </v-row>
    <br/>
  </v-container>
</template>

<script>
import {
  VCol,
  VContainer,
  VRow,
} from 'vuetify/lib'
import EventCard from '@/components/EventCard'

export default {
  components: {
    EventCard,
    VCol,
    VContainer,
    VRow,
  },
  data: () => ({
    subscribe: false,
  }),
  props: {
    aspectRatio: {
      default: '1',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    events: {
      default() {
        return []
      },
      type: Array,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    title: String,
    lg: {
      default: '4',
      type: String,
    },
  }
}
</script>

<style scoped>
h1 {
  margin-top: 20px;
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 50px !important;
  color: rgba(0, 0, 0, 0.87);
}

.join {
  text-align: center;
}
</style>
